module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('best-picture', {
    staticClass: "categoryPage bestPicture",
    class: {
      active: _vm.activeCategory == 'bestPicture', 'closing': _vm.previousCategory == 'bestPicture'
    },
    on: {
      "hamburger": _vm.hamburgerClicked,
      "clickThru": _vm.nextCategory
    }
  }), _vm._v(" "), _c('best-director', {
    staticClass: "categoryPage bestDirector",
    class: {
      active: _vm.activeCategory == 'bestDirector', 'closing': _vm.previousCategory == 'bestDirector'
    },
    on: {
      "hamburger": _vm.hamburgerClicked,
      "clickThru": _vm.nextCategory
    }
  }), _vm._v(" "), _c('best-ensemble', {
    staticClass: "categoryPage bestEnsemble",
    class: {
      active: _vm.activeCategory == 'bestEnsemble', 'closing': _vm.previousCategory == 'bestEnsemble'
    },
    on: {
      "hamburger": _vm.hamburgerClicked,
      "clickThru": _vm.nextCategory
    }
  }), _vm._v(" "), _c('best-original-screenplay', {
    staticClass: "categoryPage bestOriginalScreenplay",
    class: {
      active: _vm.activeCategory == 'bestOriginalScreenplay', 'closing': _vm.previousCategory == 'bestOriginalScreenplay'
    },
    on: {
      "hamburger": _vm.hamburgerClicked,
      "clickThru": _vm.nextCategory
    }
  }), _vm._v(" "), _c('best-actress', {
    staticClass: "categoryPage bestActress",
    class: {
      active: _vm.activeCategory == 'bestActress', 'closing': _vm.previousCategory == 'bestActress'
    },
    on: {
      "hamburger": _vm.hamburgerClicked,
      "clickThru": _vm.nextCategory
    }
  }), _vm._v(" "), _c('best-supporting-actor', {
    staticClass: "categoryPage bestSupportingActor",
    class: {
      active: _vm.activeCategory == 'bestSupportingActor', 'closing': _vm.previousCategory == 'bestSupportingActor'
    },
    on: {
      "hamburger": _vm.hamburgerClicked,
      "clickThru": _vm.nextCategory
    }
  }), _vm._v(" "), _c('best-original-score', {
    staticClass: "categoryPage bestOriginalScore",
    class: {
      active: _vm.activeCategory == 'bestOriginalScore', 'closing': _vm.previousCategory == 'bestOriginalScore'
    },
    on: {
      "hamburger": _vm.hamburgerClicked,
      "clickThru": _vm.nextCategory
    }
  }), _vm._v(" "), _c('best-cinematography', {
    staticClass: "categoryPage bestCinematography",
    class: {
      active: _vm.activeCategory == 'bestCinematography', 'closing': _vm.previousCategory == 'bestCinematography'
    },
    on: {
      "hamburger": _vm.hamburgerClicked,
      "clickThru": _vm.nextCategory
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b3a5db4","transformToRequire":{"video":["src","poster"],"source":"src","object":"data","iframe":"src","embed":"src","a":"href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CategoryPages.vue
// module id = 225
// module chunks = 0